import { isAuthoredEvalDoc } from './clinicalDocDisplay';

/**
 * SOAP and authored evaluations follow the billing guardian-evidence flag.
 * The server sets guardian_evidence_verified with hasRequiredGuardianSignatureEvidence.
 * A stored guardian name does not satisfy that flag.
 */

function docType(doc: { doc_type?: unknown } | null | undefined): string {
  return String(doc?.doc_type || '').trim().toUpperCase();
}

function requiresVerifiedGuardianEvidence(doc: { doc_type?: unknown } | null | undefined): boolean {
  const type = docType(doc);
  return type === 'SOAP' || isAuthoredEvalDoc(type);
}

export function guardianSignatureShownSigned(doc: {
  doc_type?: unknown;
  guardian_signature?: unknown;
  guardian_evidence_verified?: unknown;
} | null | undefined): boolean {
  if (requiresVerifiedGuardianEvidence(doc)) return doc?.guardian_evidence_verified === true;
  return Boolean(String(doc?.guardian_signature || '').trim());
}

export function documentFullySignedAndCleared(doc: {
  doc_type?: unknown;
  is_cleared?: unknown;
  clearance_status?: unknown;
  guardian_evidence_verified?: unknown;
} | null | undefined): boolean {
  const cleared = Boolean(doc?.is_cleared || doc?.clearance_status === 'CLEARED');
  if (!cleared) return false;
  if (requiresVerifiedGuardianEvidence(doc)) return doc?.guardian_evidence_verified === true;
  return true;
}
